export default "__VITE_ASSET__ByalQnO1__"